module.exports = __webpack_public_path__ + "static/img/04-Classic-S.adc7c8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/guitar-match/04-Classic-S.jpg
// module id = MqAZ
// module chunks = 12